import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import RootReducers from './Rootreducers';

// eslint-disable-next-line import/prefer-default-export
export function configureStore(InitialState) {
  const composeEnhancers =
    process.env.NODE_ENV === 'development'
      ? composeWithDevTools
      : compose;

  const Store = createStore(
    RootReducers,
    InitialState,
    composeEnhancers(applyMiddleware(thunk)),
  );
  return Store;
}
